import React, { useEffect } from 'react'
import Drawer from '../../../components/common/Drawer'
import { useForm } from 'react-hook-form'
import Input from '../../../components/form/input/InputField'
import Label from '../../../components/form/Label'
import { useBusiness } from '../../../context/BusinessContext'
import ColorPicker from '../../../components/common/ColorPicker'
import { api } from '../../../configs/api'
import toast from 'react-hot-toast'

const BusinessEditStep = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const { business, currentTab, currentStep, startLoading, stopLoading } = useBusiness()
    const [color, setColor] = React.useState<string>('#12B76A')
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)

    const saveDatabase = async (values: any) => {
        if (!values) return

        try {
            const formattedValues = {
                ...values,
                stepID: parseInt(values.stepID)
            }
            const response = await fetch(`${api}business/updateStep`, {
                method: 'POST',
                body: JSON.stringify(formattedValues)
            })

            const result = await response.json()
            return result.success
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const saveContext = (pipelineID: string, stepID: string, name: string) => {
        try {
            const pipelineIndex = business.pipelines.findIndex((pipeline: any) => pipeline.id === pipelineID)
            if (pipelineIndex === -1) {
                return false
            }

            const steps = business.pipelines[pipelineIndex].steps

            if (currentStep) {
                const stepIndex = steps.findIndex((step: any) => step.id == parseInt(currentStep.id))
                if (stepIndex === -1) {
                    return false
                }

                // Atualiza nome e cor da step atual
                steps[stepIndex] = { ...steps[stepIndex], title: name, color }
            }

            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const handleSave = async (data: any) => {
        const pipelineID = business.pipelines.find((pipeline: any) => pipeline.value === currentTab)?.id
        const stepID = currentStep.id
        if (!pipelineID || !stepID) return

        const values = { ...data, color, stepID, pipelineID }

        try {
            startLoading()

            //* Atualiza no BD
            const saved = await saveDatabase(values)
            if (!saved) {
                toast.error('Não foi possível alterar a fase!')
                return
            }

            //? Insere no contexto (business: pipeline => step)
            const result = saveContext(pipelineID, stepID, data.name)
            result ? toast.success('Fase alterada com sucesso!') : toast.error('Não foi possível alterar a fase!')
        } catch (error) {
            console.log(error)
        } finally {
            stopLoading()
            handleClose()
        }
    }

    useEffect(() => {
        if (currentStep) {
            form.setValue('name', currentStep.title)
            setColor(currentStep.color)
        }
    }, [open, currentStep])

    return (
        <Drawer
            open={open}
            handleClose={handleClose}
            title='Alterar fase'
            handleSave={() => formRef.current?.requestSubmit()}
            maxWidth='max-w-xl'
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleSave)}>
                <div className='space-y-3'>
                    <div>
                        <Label required>Nome da fase</Label>
                        <Input {...form.register('name', { required: true })} placeholder='Nome da fase' />
                    </div>
                    <div>
                        <Label>Cor</Label>
                        <ColorPicker color={color} onChange={setColor} />
                    </div>
                </div>
            </form>
        </Drawer>
    )
}

export default BusinessEditStep
